export class CArticle {
    constructor() {
        this.id = '';
        this._legacyId = 0;
        this.title = '';
        this.author = '';
        this.created = 0;
        this.modified = 0;
        this.priority = 0;
        this.estimatedReadingTime = 0;
        this.referenceLink = '';
        this.mimeType = '';
        this.type = '';
        this.client = [''];
        this.slug = '';
        this.status = '';
        this.image = '';
        this.content = '';
        this.excerpt = '';
        this.region = '';
        this.language = '';
        this.tags = [''];
        this.showInLibrary = false;
        this.exclude = [''];
        this.internalTags = [''];
        this.categories = [''];
        this.contentType = '';
        this.source = '';
        this._rid = '';
        this._self = '';
        this._etag = '';
        this._attachments = '';
        this._ts = 0;
    }
}
//# sourceMappingURL=article.js.map